import { Loading } from "components/shared";
import { Button } from "components/ui";
import InputModern from "components/ui/Input/InputModern";
import React, { useState } from "react";
import { HiOutlineUser } from "react-icons/hi2";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";


const ChangeSpeaker = (props) => {

    const [ customSpeaker, setCustomSpeaker ] = useState("");
    const { isLoading, input, run, writeBackReplace, closeMenu } = useMagicAction(props);

    const handleOnClick = () => {
        if (!customSpeaker) {
            return;
        }
        run({
            prompt: `Rewrite the following text as if written by ${customSpeaker}.\n\nTEXT:\n${input}`,
            schema: RESULT_SCHEMA,
        })
            .then((r) => writeBackReplace(asText(r)))
            .finally(closeMenu);
    }


    return (
        <div className="flex items-center justify-center p-0 gap-2">
            {isLoading
                ? <Loading type={'element'} />
                :
                <div className="flex flex-col gap-2 w-full">
                    <InputModern
                        autoFocus
                        value={customSpeaker}
                        onChange={(e) => setCustomSpeaker(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !isLoading) {
                                e.preventDefault();
                                handleOnClick();
                            }
                        }}
                        placeholder={`Try "Jack Sparrow"`}
                    />
                    <div className="items-center w-full">
                        <Button loading={isLoading} disabled={isLoading} onClick={handleOnClick} className="w-full" variant="solid" icon={<HiOutlineUser />}>&nbsp; Change Speaker</Button>
                    </div>
                </div>
            }

        </div>
    )
}

export default ChangeSpeaker;
